import { css } from "@linaria/core";
import React, { memo, useMemo } from "react";
import { CheckboxBlankCircleFill } from "@ui/IconV2/react";
import Text from "@ui/Text";
import { getDefaultColor } from "../../../Block/Plot/utils/mark";
import t from "../../../../../../../../../i18n";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";
import { useAvailableResources } from "../../../../../../hook/useAvailableResources";

const LayerEncodingContainer = css`
  display: grid;
  grid-template-columns: max-content 1fr;
  grid-template-rows: repeat(2, max-content);
  column-gap: 8px;

  svg {
    align-self: center;
  }

  p {
    grid-column: 1 / span 2;
  }

  svg + p {
    grid-column: 2 / span 1;
  }
`;

const layerEncodingIdentifier = css`
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
`;

const layerEncodingColumn = css`
  overflow: hidden;
  overflow-wrap: normal;
  text-overflow: ellipsis;
`;

export const LayerEncoding = memo(
  ({
    projectId,
    layer,
    encoding,
  }: {
    projectId: string;
    layer: number;
    encoding: { identifier: string; column: string; quantity?: string };
  }) => {
    const { block, preset } = useGUIEditorContext();
    const color = getDefaultColor(layer);
    const availableResources = useAvailableResources({ projectId });

    const displayName = availableResources.fault.identifiers.find(
      i => i.name === encoding.identifier,
    )?.displayName;

    const identifierName = displayName ? displayName : encoding.identifier;

    const displayedColor = useMemo(
      () =>
        preset === "scatter" && block?.config.layers.every(l => l.encoding.color)
          ? undefined
          : color,
      [preset, block?.config.layers, color],
    );

    return (
      <div className={LayerEncodingContainer}>
        {displayedColor && preset === "line" && (
          <CheckboxBlankCircleFill color={displayedColor} size="xs" />
        )}
        <Text type="body1SemiBold" className={layerEncodingIdentifier}>
          {identifierName}
        </Text>
        <Text className={layerEncodingColumn}>
          <span style={{ whiteSpace: "nowrap" }}>
            {t("project.dashboard.resource.column", encoding.column)} {encoding.quantity}
          </span>
        </Text>
      </div>
    );
  },
);
